/**
 * useFeatureFlags — hook to read restaurant feature flags from branding context
 *
 * Feature flags come from the restaurant's subscription plan, exposed via
 * the branding endpoint. All flags default to true for backwards compatibility
 * (existing restaurants without explicit flags work as before).
 */

import { useBranding } from '../context/BrandingContext';

const DEFAULT_FLAGS = {
  customerAppEnabled: true,
  deliveryEnabled: true,
  takeawayEnabled: true,
  paymentIntegrationsEnabled: true,
  waitingQueueEnabled: true,
  smartMenuPopularityEnabled: true,
  smartMenuPromosEnabled: true,
  smartMenuScheduleEnabled: true,
};

export function useFeatureFlags() {
  const { featureFlags } = useBranding();
  const flags = { ...DEFAULT_FLAGS, ...(featureFlags || {}) };

  return {
    ...flags,
    /**
     * Check if a specific feature flag is enabled
     */
    isEnabled: (flagName) => flags[flagName] !== false,
  };
}
